import { render, staticRenderFns } from "./IconDuplicateOutline.vue?vue&type=template&id=d0b934f0"
import script from "./IconDuplicateOutline.vue?vue&type=script&lang=js"
export * from "./IconDuplicateOutline.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports